// Parking spots are loaded from the backend / program data — not a baked-in airfield.
export const parkingSpots = [];

export const statusColors = {
  'UP': '#28a745',
  'DN': '#dc3545',
  'DS': '#dc3545',
  'PM': '#ffc107',
  'FCF': '#8716bbff',
  'AWP': '#335d80ff',
  'OTH': '#6c757d',
  'DET': '#6c757d',
  'AIMD': '#6c757d',
  'REI': '#6c757d',
  '': '#e9ecef'
};

export const statusDescriptions = {
  'UP': 'Up - Aircraft is operational',
  'DN': 'Down - Aircraft is not operational',
  'DS': 'Down for Supply - Aircraft is NMCS',
  'PM': 'Planned Maintenance - Aircraft is under maintenance',
  'FCF': 'Functional Check Flight - Aircraft is being tested',
  'AWP': 'Awaiting Part - Aircraft is awaiting parts',
  'OTH': 'Other - Aircraft status is other',
  'DET': 'Detached - Aircraft is detached from unit',
  'AIMD': 'Aircraft Intermediate Maintenance Department - Aircraft is at AIMD',
  'REI': 'Engineering - Aircraft is being REI/TEI',
  '': 'Empty - No aircraft assigned'
};
